// @ts-ignore
import * as dynamic from './dynamic/i18n.en';
import { ITranslations } from './types';

const i18n: ITranslations = {};
i18n['agencies'] = {};
i18n['agencies']['budget-asc-order'] = "";
i18n['agencies']['budget-desc-order'] = "";
i18n['agencies']['budget-from'] = "";
i18n['agencies']['budget-to'] = "";
i18n['agencies']['budgets'] = "";
i18n['agencies']['certificates'] = "Service";
i18n['agencies']['cities'] = "City";
i18n['agencies']['city'] = "City";
i18n['agencies']['countries'] = "Country";
i18n['agencies']['country'] = "Country";
i18n['agencies']['currency'] = "";
i18n['agencies']['filter-all-cities-name'] = "All cities";
i18n['agencies']['filter-all-cities-name-prepositional'] = "all cities";
i18n['agencies']['filter-all-cities-preposition'] = "in";
i18n['agencies']['filters-conjunction'] = " and ";
i18n['agencies']['filters-delimiter'] = ", ";
i18n['agencies']['filters-reset'] = "Reset filters";
i18n['agencies']['not-found'] = "No agencies match these criteria. Please reset your filters and try again.";
i18n['agencies']['only-offices-found'] = "Branches of agencies certified in other cities match the set criteria.";
i18n['agencies']['only-partners-found'] = "Branches of agencies without current certifications match the set criteria.";
i18n['agencies']['other-offices'] = "Agencies with branches certified in other cities";
i18n['agencies']['other-partners'] = "Agencies without current certifications";
i18n['agencies']['region-choose'] = "Select a country";
i18n['agencies']['search'] = "Search";
i18n['agencies']['service'] = "Service";
i18n['agencies']['show-text'] = "";
i18n['agencies']['specify'] = "Please specify";
i18n['agencies']['text'] = "Use this page to search by location for agencies who work with Yandex. Use the drop-down menus to select a city and the service(s) that interest you.";
i18n['agencies']['title'] = "Certified Agencies";
i18n['dashboard'] = {};
i18n['dashboard']['cat.1239063375'] = "Electronics";
i18n['dashboard']['cat.1412163005'] = "Automotive: services";
i18n['dashboard']['cat.1473509328'] = "Education and employment";
i18n['dashboard']['cat.1582506554'] = "Clothing and footwear";
i18n['dashboard']['cat.1644710081'] = "Home and garden";
i18n['dashboard']['cat.200304283'] = "Automotive: products";
i18n['dashboard']['cat.2107020788'] = "Other";
i18n['dashboard']['cat.2222683737'] = "Medicine";
i18n['dashboard']['cat.2408536966'] = "Household services and catering";
i18n['dashboard']['cat.2455984605'] = "UNKNOWN";
i18n['dashboard']['cat.2473087795'] = "Legal services and consulting";
i18n['dashboard']['cat.2587886448'] = "Construction and renovation: products";
i18n['dashboard']['cat.3119845291'] = "Gifts";
i18n['dashboard']['cat.3315302486'] = "Construction and renovation: services";
i18n['dashboard']['cat.3566538395'] = "FMCG";
i18n['dashboard']['cat.3737414780'] = "Household appliances";
i18n['dashboard']['cat.3989916053'] = "Real estate";
i18n['dashboard']['cat.4170831985'] = "Travel and tourism";
i18n['dashboard']['cat.4194169969'] = "B2B";
i18n['dashboard']['cat.491274388'] = "Entertainment and media";
i18n['dashboard']['cat.518209040'] = "Sporting goods and services";
i18n['dashboard']['cat.570002290'] = "FOR_TOTAL_COUNTER";
i18n['dashboard']['cat.676268400'] = "IT and telecommunications";
i18n['dashboard']['cat.80967844'] = "Finance and insurance";
i18n['dashboard']['cat.auto'] = "Auto";
i18n['dashboard']['cat.consulting'] = "Consulting";
i18n['dashboard']['cat.finance'] = "Finance";
i18n['dashboard']['cat.realty'] = "Real estate";
i18n['dashboard']['cat.retail'] = "Retail";
i18n['dashboard']['comparison.add'] = "Add to comparison";
i18n['dashboard']['comparison.delete'] = "Delete comparison";
i18n['dashboard']['error.modal'] = "Data for these parameters is either unavailable or being processed";
i18n['dashboard']['error.widget'] = "Could not display data. Please try again later.";
i18n['dashboard']['platform.desktop'] = "PC";
i18n['dashboard']['platform.mobile'] = "Mobile";
i18n['dashboard']['region.1'] = "Moscow and Moscow region";
i18n['dashboard']['region.10174'] = "Saint Petersburg and Leningrad region";
i18n['dashboard']['region.102444'] = "Northern Caucusus Federal District";
i18n['dashboard']['region.17'] = "North-West Federal District (excluding Saint Petersburg and Leningrad region)";
i18n['dashboard']['region.17,-2'] = "North West Federal District";
i18n['dashboard']['region.225'] = "Russia";
i18n['dashboard']['region.26'] = "South Federal District";
i18n['dashboard']['region.3'] = "Central Federal District (excluding Moscow and Moscow region)";
i18n['dashboard']['region.3,-213'] = "Central Federal District";
i18n['dashboard']['region.40'] = "Volga Federal District";
i18n['dashboard']['region.52'] = "Ural Federal District";
i18n['dashboard']['region.59'] = "Siberian Federal District";
i18n['dashboard']['region.73'] = "Far East Federal District";
i18n['dashboard']['title.add'] = "Add comparison";
i18n['dashboard']['title.remove'] = "Remove comparison";
i18n['dashboard']['type.interest'] = "Change in interest, weekly";
i18n['dashboard']['type.network'] = "YAN. Change in CPC, weekly";
i18n['dashboard']['type.search'] = "Search. Change in CPC, weekly";
i18n['dashboard']['widget.type.interest'] = "Speed of change of interest";
i18n['offices'] = {};
i18n['offices']['readmore'] = "Find out more";
i18n['news'] = {};
i18n['news']['400_CII'] = "because this comment does not exist";
i18n['news']['400_LII'] = "something went wrong. Please refresh the page and try again";
i18n['news']['400_SII'] = "because the page address contains invalid characters. Please check the address, refresh the page, and try again";
i18n['news']['400_VFL'] = "because several fields may not be filled or may contain invalid values. Please correct this and try again";
i18n['news']['401_NAU'] = "because you are not logged in. Please enter your login credentials and try again";
i18n['news']['403_CCI'] = "the code entered is incorrect";
i18n['news']['403_PRO'] = "because the author has disabled comments";
i18n['news']['403_UAC'] = "because you have already made a complaint. This can only be done once";
i18n['news']['403_UBN'] = "because you have been banned by the moderator";
i18n['news']['403_UNM'] = "because an access error has occurred. Please refresh the page and try again";
i18n['news']['413_ETL'] = function(params) { return "because it contains more than " + params["maxCommentSize"] + " characters" };
i18n['news']['500_ISE'] = "something went wrong. Please wait a little while and try again";
i18n['news']['breadcrumb'] = "Main news";
i18n['news']['comments'] = "Comments";
i18n['news']['comments.add_error'] = function(params) { return "Unable to create comment, " + params["reason"] };
i18n['news']['comments.banned'] = "";
i18n['news']['comments.bound-phone'] = "";
i18n['news']['comments.bound-phone-text'] = "";
i18n['news']['comments.complain_error'] = function(params) { return "Unable to send complaint about comment, " + params["reason"] };
i18n['news']['comments.count'] = function(params) { return params["count"] + " " + dynamic.plural_adv({"count": "         " + params["count"] + "     ", "one": "comment", "some": "comments", "many": "comments", "none": "comments"}) };
i18n['news']['comments.enter-url'] = "";
i18n['news']['comments.get_error'] = function(params) { return "Unable to receive comments " + params["reason"] + "." };
i18n['news']['comments.hint'] = "To change the font or add a link, highlight part of the text.";
i18n['news']['comments.load-captcha_error'] = function(params) { return "Unable to receive CAPTCHA " + params["reason"] + "." };
i18n['news']['comments.non-authorized'] = "Log in to leave a comment";
i18n['news']['comments.removed'] = "";
i18n['news']['comments.send'] = "Send";
i18n['news']['comments.unavailable'] = "";
i18n['news']['comments.your-reply'] = "Reply for";
i18n['news']['comments.your-word'] = "Enter your comment here,";
i18n['news']['complaint'] = "Complain";
i18n['news']['complaint.question'] = "Report this comment?";
i18n['news']['default_error'] = "something went wrong. Please try again later";
i18n['news']['edu.nav.list'] = "Back to lesson list";
i18n['news']['edu.nav.next'] = "Go to next lesson";
i18n['news']['filters.clear'] = "Clear filters";
i18n['news']['for_all_time'] = "All time";
i18n['news']['index.archive'] = "News archive";
i18n['news']['index.title'] = "Advertising news";
i18n['news']['related.title'] = "You might also find interesting:";
i18n['news']['reply'] = "Reply";
i18n['news']['tags'] = "All topics";
i18n['edu'] = {};
i18n['edu']['answer'] = "Submit";
i18n['edu']['city'] = "City";
i18n['edu']['company'] = "Company";
i18n['edu']['contact'] = "Contact";
i18n['edu']['country'] = "Country";
i18n['edu']['events'] = "Events";
i18n['edu']['expert.readyToComeInYourCity'] = "Ready to travel to your city";
i18n['edu']['expert.readyToTrips'] = "Ready for business trips";
i18n['edu']['leave.feedback'] = "Leave a feedback";
i18n['edu']['lesson-content'] = "You can learn in this lesson";
i18n['edu']['lessons.list'] = "All lessons";
i18n['edu']['months'] = "Months";
i18n['edu']['next.lesson'] = "Next lesson";
i18n['edu']['online'] = "Online";
i18n['edu']['prev.lesson'] = "Previous lesson";
i18n['edu']['reviews'] = "Feedback";
i18n['edu']['specialization'] = "Specialization";
i18n['edu']['starts.at'] = "start at";
i18n['edu']['themes'] = "All themes";
i18n['edu']['user.certificate'] = function(params) { return "Certificate of " + params["lastname"] };
i18n['edu']['workFormat'] = "";
i18n['solutions'] = {};
i18n['solutions']['analytics'] = "Analytics";
i18n['solutions']['cases'] = "Cases";
i18n['solutions']['changes'] = "";
i18n['solutions']['city'] = "City";
i18n['solutions']['clear'] = "Clear";
i18n['solutions']['companySize'] = "Company size";
i18n['solutions']['error'] = "Unable to load solutions. Please try again later.";
i18n['solutions']['industries'] = "Industry";
i18n['solutions']['periods'] = "";
i18n['solutions']['practicums'] = "";
i18n['solutions']['products'] = "Products";
i18n['solutions']['read.more'] = "Read more";
i18n['solutions']['registration.year'] = "Company founded";
i18n['solutions']['site'] = "Website";
i18n['solutions']['stories'] = "Success stories";
i18n['solutions']['tasks'] = "Goals";
i18n['solutions']['yandex.year'] = "Working with Yandex since";
i18n['pages'] = {};
i18n['pages']['contact.description'] = "Sales offices and ad agencies";
i18n['pages']['contact.keywords'] = "Sales offices, support service, agencies";
i18n['pages']['contact.title'] = "Contacts  — Yandex.Advertising";
i18n['pages']['index.description'] = "";
i18n['pages']['index.keywords'] = "";
i18n['pages']['index.title'] = "Advertising on Yandex — Yandex.Advertising";
i18n['pages']['news.title'] = "News — Yandex.Advertising";
i18n['pages']['order.title'] = "Place an ad";
i18n['pages']['partners-news.title'] = "News from closed section";
i18n['pages']['partners.title'] = "For ad agencies";
i18n['pages']['requirements.title'] = "Requirements for ad materials";
i18n['pages']['subscription.partners.title'] = "Subscribe to news for ad agencies";
i18n['pages']['subscription.public.title'] = "Subscribe to ad tech news";
i18n['agency'] = {};
i18n['agency']['add-office'] = "";
i18n['agency']['address'] = "Address";
i18n['agency']['agencies-with-certificates'] = function(params) { return "You can view certified agencies <a href=\"" + params["agenciesPageUrl"] + "\">here</a>." };
i18n['agency']['agency-experience'] = "Agency experience";
i18n['agency']['allagencies'] = "All agencies";
i18n['agency']['back-to-edit'] = "";
i18n['agency']['bidder'] = "Yandex Bid Management Partner";
i18n['agency']['budget'] = "";
i18n['agency']['budget-placeholder'] = "";
i18n['agency']['cancel-editing'] = "";
i18n['agency']['card-link'] = "Read more";
i18n['agency']['case'] = "Case";
i18n['agency']['certificate_plate'] = "https://avatars.mds.yandex.net/get-adv/121152/2a00000165e84069c02b6d7892ce990466c1/orig";
i18n['agency']['certificate_title'] = "Yandex certified agency";
i18n['agency']['certificates'] = "Certificates";
i18n['agency']['certified-yandex-agency'] = "Yandex certified agency";
i18n['agency']['city'] = "City";
i18n['agency']['contact-info'] = "Contact information";
i18n['agency']['description-placeholder'] = "";
i18n['agency']['edit'] = "";
i18n['agency']['editing-mode'] = "";
i18n['agency']['email'] = "Email";
i18n['agency']['feedback'] = "Contact this agency";
i18n['agency']['form.button'] = "Send";
i18n['agency']['form.email'] = "Your email address";
i18n['agency']['form.message'] = "Message body";
i18n['agency']['form.name'] = "Your name";
i18n['agency']['full-description-counter'] = "";
i18n['agency']['material-error'] = "";
i18n['agency']['material-placeholder'] = "";
i18n['agency']['materials'] = "Agency materials";
i18n['agency']['modal.title'] = "Contact this agency";
i18n['agency']['name-placeholder'] = "";
i18n['agency']['next'] = "Next";
i18n['agency']['non-active-agency'] = "This agency does not have current certifications.";
i18n['agency']['on-moderation'] = "";
i18n['agency']['phone'] = "Phone";
i18n['agency']['prev'] = "Previous";
i18n['agency']['preview-description-counter'] = "";
i18n['agency']['qualified-yandex-partner'] = "Yandex Qualified Partner";
i18n['agency']['readmore'] = "Find out more";
i18n['agency']['remove'] = "";
i18n['agency']['send-to-moderation'] = "";
i18n['agency']['sending-fail'] = "";
i18n['agency']['show-phone'] = "Show number";
i18n['agency']['show-preview'] = "";
i18n['agency']['site'] = "Website";
i18n['agency']['specialization'] = "Specialization";
i18n['agency']['type.appmetrica'] = "Mobile ads";
i18n['agency']['type.bidder'] = "Yandex Direct Bid Management Partner";
i18n['agency']['type.dialogs'] = "Yandex Dialogues";
i18n['agency']['type.direct'] = "Direct";
i18n['agency']['type.geomapadv'] = "Yandex Business";
i18n['agency']['type.geonaviadv'] = "Navigator";
i18n['agency']['type.market'] = "Yandex Market";
i18n['agency']['type.media-adv'] = "";
i18n['agency']['type.metrika'] = "Metrica";
i18n['agency']['type.promopages'] = "PromoPages";
i18n['agency']['type.retargeting'] = "Ecomm+";
i18n['agency']['type.toloka'] = "Yandex Toloka";
i18n['agency']['type.zen'] = "PromoPages";
i18n['agency']['yandex-partner'] = "Yandex Partner";
i18n['agency']['yandex-leading-partner'] = "Yandex Leading Partner";
i18n['search'] = {};
i18n['search']['0'] = "News";
i18n['search']['1'] = "Contextual advertising";
i18n['search']['2'] = "Media advertisment";
i18n['search']['3'] = "Mobile advertisment";
i18n['search']['4'] = "Classifieds";
i18n['search']['5'] = "Geo advertisment";
i18n['search']['6'] = "Cases and Success Stories";
i18n['search']['7'] = "Education";
i18n['search']['8'] = "Contacts";
i18n['search']['9'] = "Requirements";
i18n['search']['all.pages'] = "All pages";
i18n['search']['find'] = "Find";
i18n['search']['found'] = "Results for";
i18n['search']['materials'] = "Materials";
i18n['search']['not.found'] = "Nothing was found matching your request.";
i18n['search']['partners'] = "Partners";
i18n['search']['search'] = "Search";
i18n['search']['site.search'] = "";
i18n['search']['switch.left'] = "← + Alt";
i18n['search']['switch.right'] = "Alt + →";
i18n['header'] = {};
i18n['header']['service.adv'] = "For advertisers";
i18n['header']['service.blog'] = "Blog";
i18n['header']['service.company'] = "Company";
i18n['header']['service.edu'] = "Education";
i18n['header']['service.events'] = "Events";
i18n['header']['service.science'] = "Research";
i18n['header']['service.tech'] = "For developers";
i18n['header']['service.vacancies'] = "Jobs";
i18n['products'] = {};
i18n['products']['link'] = "All prices";
i18n['products']['more'] = "Show more";
i18n['products']['more-detailed'] = "";
i18n['products']['more.button'] = "Find out more";
i18n['products']['order.button'] = "Contact us";
i18n['products']['targetings'] = "Targeting types:";
i18n['products']['terms'] = "Full terms by product";
i18n['months'] = {};
i18n['months']['g1'] = "Jan";
i18n['months']['g10'] = "Oct";
i18n['months']['g11'] = "Nov";
i18n['months']['g12'] = "Dec";
i18n['months']['g2'] = "Feb";
i18n['months']['g3'] = "Mar";
i18n['months']['g4'] = "Apr";
i18n['months']['g5'] = "May";
i18n['months']['g6'] = "Jun";
i18n['months']['g7'] = "Jul";
i18n['months']['g8'] = "Aug";
i18n['months']['g9'] = "Sep";
i18n['months']['n1'] = "January";
i18n['months']['n10'] = "October";
i18n['months']['n11'] = "November";
i18n['months']['n12'] = "December";
i18n['months']['n2'] = "February";
i18n['months']['n3'] = "March";
i18n['months']['n4'] = "April";
i18n['months']['n5'] = "May";
i18n['months']['n6'] = "June";
i18n['months']['n7'] = "July";
i18n['months']['n8'] = "August";
i18n['months']['n9'] = "September";
i18n['file-upload'] = {};
i18n['file-upload']['files-limit-error'] = function(params) { return "You can add no more than " + params["count"] + " " + dynamic.plural_adv({"count": params["count"], "one": "file", "some": "files", "many": "files", "none": "files"}) };
i18n['file-upload']['limit-hint'] = function(params) { return "A maximum of " + params["count"] + " " + dynamic.plural_adv({"count": params["count"], "one": "file", "some": "files", "many": "files", "none": "files"}) + " " + dynamic.toggle({"condition": params["multiple"], "true": "", "false": ""}) + " with a size of up to " + params["size"] + " MB" };
i18n['file-upload']['size-limit-error'] = function(params) { return "The size of uploaded files exceeds " + params["size"] + " MB" };
i18n['file-upload']['upload-text'] = "Upload";
i18n['sections'] = {};
i18n['sections']['analytics'] = "Analytics";
i18n['sections']['contact'] = "Contact information";
i18n['sections']['distribution'] = "Distribution";
i18n['sections']['edu.events'] = "We recommend visiting";
i18n['sections']['edu.experts'] = "Training partners";
i18n['sections']['education'] = "Education";
i18n['sections']['index'] = "Home";
i18n['sections']['monetization'] = "Monetization";
i18n['sections']['news'] = "Yandex advertising news";
i18n['sections']['order'] = "Place an ad";
i18n['sections']['partners'] = "For ad agencies";
i18n['sections']['publishers'] = "For publishers";
i18n['sections']['requirements'] = "Advertising requirements";
i18n['sections']['subscription.partners'] = "Subscribe to news for ad agencies";
i18n['sections']['subscription.public'] = "Subscribe to the Yandex Ad Tech Newsletter";
i18n['sections']['subscription.publishers'] = "Subscribe to the monetization technology newsletter for publishers and site owners";
i18n['sections']['subscription.subs'] = "Subscribe to the Yandex Ad Tech Newsletter";
i18n['menu'] = {};
i18n['menu']['agency'] = "Local advertising agencies";
i18n['menu']['backward'] = "Back";
i18n['menu']['backward-section'] = "";
i18n['menu']['menu'] = "Menu";
i18n['menu']['offices'] = "Sales offices";
i18n['menu']['order'] = "Contact us";
i18n['menu']['support'] = "Support service";
i18n['support'] = {};
i18n['support']['feedback.form'] = "Send message";
i18n['support']['feedback.link'] = "Feedback form";
i18n['materials'] = {};
i18n['materials']['error'] = "";
i18n['partners'] = {};
i18n['partners']['button.back'] = "Back";
i18n['partners']['button.next'] = "Next";
i18n['partners']['button.send'] = "Send request";
i18n['partners']['followTheNews'] = "Keep up to date with our latest news";
i18n['partners']['form.direct'] = "Yandex.Direct";
i18n['partners']['form.directAndMarket'] = "Yandex.Direct + Yandex.Market";
i18n['partners']['form.disk.button'] = "Upload feed to Yandex.Disk";
i18n['partners']['form.disk.modal.1'] = "Go to <a href=\"https://disk.yandex.ru\" target=\"_blank\">Yandex.Disk</a> and click \"Upload.\" Select your feed in the window that opens.";
i18n['partners']['form.disk.modal.2'] = "";
i18n['partners']['form.disk.pseudolink'] = "How to load files to Yandex.Disk";
i18n['partners']['form.emptyValue'] = "–";
i18n['partners']['form.error.email'] = "Incorrect email address";
i18n['partners']['form.error.required'] = "This is a required field";
i18n['partners']['form.market'] = "Yandex.Market";
i18n['partners']['form.tip'] = "All fields are required";
i18n['partners']['form.ty.contract'] = "Thank you!\nWe will process your request and contact you within the next two working days.";
i18n['partners']['form.ty.login'] = "Thank you!\nWe will process your request and contact you within the next two working days.";
i18n['partners']['form.ty.title'] = "Thank you. Your request has been sent!";
i18n['partners']['goal.chooseGoal'] = "Select a goal";
i18n['partners']['goal.chooseGoal.text'] = "Please keep in mind that to sign a contract you must meet the minimal requirements . You can read about them <a href=\"/adv/partners\">here</a>";
i18n['partners']['goal.contract'] = "I already have a username and I'd like to sign a contract";
i18n['partners']['goal.contract.text'] = "Before sending the request, make sure that you have logged in under your agency username with all your clients. If you don't have such a username, select the goal \"I'd like a username and a contract.\"";
i18n['partners']['goal.login'] = "I'd like an agency username for access to the interface";
i18n['partners']['goal.login.direct.text'] = "The Yandex.Direct agent interface was designed with agencies in mind: you can manage all of your clients in one place, and your managers can work with their specific clients. There are no minimal requirements to gain access to the interface as long as you are an agency. Simply send a request, and we will contact you within two working days.";
i18n['partners']['goal.login.directAndMarket.text'] = "The agency interface was developed specifically for ad agencies. In one place, agencies can add all their clients, manage placements in both Yandex.Direct and Yandex.Market, and grant each manager access to the accounts they need.\nThere are no special conditions to receive access to the interface — being an agency is sufficient. Send us a request and we will contact you within two working days.";
i18n['partners']['goal.login.market.text'] = "The agency interface allows agencies to manage all their clients' placements in one place and each manager can work with only the accounts they need.\nThere are no special conditions to receive access to the interface — being an agency is sufficient. Send us a request and we will contact you within two working days.";
i18n['partners']['menu.becomePartner'] = "Become a Yandex partner";
i18n['partners']['products'] = "Other Yandex products that could be of interest to your clients:";
i18n['partners']['step1'] = "Step 1: General Information";
i18n['partners']['step2'] = "Step 2: Your agency's goals";
i18n['forms'] = {};
i18n['forms']['400_SMF'] = "Unable to complete subscription";
i18n['forms']['400_SNA'] = function(params) { return "Unable to complete subscription for " + params["param"] };
i18n['forms']['400_SNS'] = "Please select as least one";
i18n['forms']['403_CCI'] = "the code entered is incorrect";
i18n['forms']['403_ICT'] = "An error occurred. Please try again later.";
i18n['forms']['503_MNS'] = "Could not send message. Please try again.";
i18n['forms']['captcha'] = "Please enter the code in the image:";
i18n['forms']['captcha.change'] = "Change code";
i18n['forms']['emptyValue'] = "–";
i18n['forms']['error'] = "Something went wrong. Please try again later.";
i18n['forms']['error.server'] = "Something went wrong. Please try again.";
i18n['forms']['form'] = "Form";
i18n['forms']['label.comment'] = "Comment";
i18n['forms']['label.email'] = "Your email";
i18n['forms']['label.login'] = "Yandex username";
i18n['forms']['label.name'] = "Your name";
i18n['forms']['label.phone'] = "Phone number";
i18n['forms']['label.region'] = "Region";
i18n['forms']['label.site'] = "Website";
i18n['forms']['subscribed.multi.text'] = "Please check your inbox. You must confirm each individual subscription.";
i18n['forms']['subscribed.multi.title'] = "Thank you!";
i18n['forms']['subscribed.single.text'] = "Please check your inbox.";
i18n['forms']['subscribed.single.title'] = "Thank you!";
i18n['forms']['subscription.button'] = "Subscribe";
i18n['forms']['subscription.button.register'] = "Register";
i18n['forms']['success.agency.text'] = "Your message has been sent to the agency.";
i18n['forms']['success.agency.title'] = "Thank you!";
i18n['forms']['success.def.text'] = "Please do not send duplicate messages. Our specialists will reply to you.";
i18n['forms']['success.def.title'] = "Your message has been sent";
i18n['filters'] = {};
i18n['filters']['clear'] = "Clear filters";
i18n['order'] = {};
i18n['order']['agency'] = "Through an ad agency";
i18n['order']['chooseAgency'] = "Select an agency";
i18n['order']['city'] = "city";
i18n['order']['country'] = "Country";
i18n['order']['createAd'] = "Create an ad";
i18n['order']['form'] = "With a Yandex manager";
i18n['order']['personally'] = "Directly";
i18n['order']['pleaseSpecifyYourLocation'] = "Select the city you are closest to:";
i18n['order']['sendForm'] = "Send";
i18n['order']['title'] = "Place an ad";
i18n['common'] = {};
i18n['common']['addUser'] = "Switch usernames";
i18n['common']['amp-breadcrumb'] = "News";
i18n['common']['and'] = "and";
i18n['common']['comdi.not-supported'] = "Broadcast unavailable in your browser version. Try using <a href=\"https://browser.yandex.ru\" target=\"_blank\">Yandex Browser</a>";
i18n['common']['conditions'] = "Conditions";
i18n['common']['days'] = "";
i18n['common']['facebook'] = "Facebook";
i18n['common']['habrahabr'] = "Habrahabr";
i18n['common']['hours'] = "";
i18n['common']['instagram'] = "Instagram";
i18n['common']['linkedin'] = "LinkedIn";
i18n['common']['loading-error'] = "Error loading";
i18n['common']['login'] = "Sign in";
i18n['common']['logout'] = "Sign out";
i18n['common']['media.cases'] = "Cases";
i18n['common']['media.courses'] = "Training";
i18n['common']['media.stories'] = "Success stories";
i18n['common']['minutes'] = "";
i18n['common']['more.button.error'] = "Something went wrong. Please try again later.";
i18n['common']['more.button.text'] = "Show more";
i18n['common']['news-is-not-available'] = "The news section is currently unavailable.<br/> Please try again later.";
i18n['common']['no'] = "No";
i18n['common']['oldbrowser.close'] = "Close";
i18n['common']['oldbrowser.download'] = "Update browser";
i18n['common']['oldbrowser.text'] = "The service's functionality is not guaranteed";
i18n['common']['online.edu'] = "Online-education";
i18n['common']['project.name'] = "Advertising technology";
i18n['common']['rss'] = "RSS";
i18n['common']['search.all_pages'] = "All pages";
i18n['common']['seconds'] = "";
i18n['common']['show-full'] = "Read in full";
i18n['common']['swipe.slideInfo'] = "of";
i18n['common']['twitter'] = "Twitter";
i18n['common']['vkontakte'] = "Vkontakte";
i18n['common']['yes'] = "Yes";
i18n['common']['youtube'] = "YouTube";
i18n['common']['сancel'] = "Cancel";

export default i18n;